import { useTheme } from "@mui/material";
import TopBarProgress from "react-topbar-progress-indicator";

const TopBarProgressbar = () => {
  const theme = useTheme();

  TopBarProgress.config({
    barColors: {
      "0": theme.palette.primary.light,
      "0.25": theme.palette.primary.dark,
      "0.75": theme.palette.secondary.dark,
      "1": theme.palette.secondary.light,
    },
    shadowBlur: 0,
  });

  return <TopBarProgress />;
};

export { TopBarProgressbar };
